<script lang="ts">
	import AppFooter from '#lib/layouts/app-footer.svelte'
	import AppHeader from '#lib/layouts/app-header.svelte'

	let { children } = $props()
</script>

<AppHeader />

{@render children?.()}

<AppFooter />
